export default {
  /**
   * This will check all the routes set in the data object
   * It will check the route stored in the router, check the meta permissions and deny or allow access
   * This will essentially render the link or not
   */
  created() {
    const allRoutes = this.$router.options.routes;

    this.routes.forEach((route) => {
      if (!route.route) {
        return;
      }

      const foundRoute = allRoutes.find(r => r.name === route.route.name);

      // Disable the route (show it)
      if (!foundRoute) {
        route.disabled = true;
        route.access = true;
        return;
      }

      const { meta } = foundRoute;

      if (!meta || !meta.permissions) {
        route.access = true;
        return;
      }

      // currently AND only
      let access = false;
      meta.permissions.forEach((p) => {
        access = this.$can(p.action, p.subject);
      });

      route.access = access;
    });
  },
};
